import { NOT_FOUND } from 'http-status-codes';
import { takeLatest, put, select } from 'redux-saga/effects';
import { getDetailSaga } from '../../../store/structures';
import { types, actions } from './duck';
import { getDetail } from '../../coupons/api';
import * as businessDetailsModule from '../../businesses/details/duck';
import { markAsFavouriteSaga, removeFavouriteSaga } from '../favourite/saga';

export function* getDetailRequest(id) {
  const response = yield getDetail(id);

  if (response.status === NOT_FOUND) {
    // Run removing coupon from "recommended and all" lists.
    yield put(actions.removeCoupon(id));

    const existingState = yield select(state => state.coupons.details[id]);
    const existingData = existingState && existingState.data;
    // Extract related business id if coupon state exist.
    const relatedBusinessId =
      existingData && existingData.business && existingData.business.id;

    if (relatedBusinessId) {
      // Refresh business detail data to update related coupons list.
      yield put(businessDetailsModule.actions.getDetail(relatedBusinessId));
    }
  }
  return response;
}

export default function* saga() {
  yield takeLatest(types.GET_DETAIL, getDetailSaga(actions, getDetailRequest));
  yield takeLatest(types.MARK_AS_FAVOURITE, markAsFavouriteSaga);
  yield takeLatest(types.REMOVE_FAVOURITE, removeFavouriteSaga);
}